module.exports = __webpack_public_path__ + "img/ico8.d9380154.png";